import global_axios from '../../funciones_globales/interaccionapi';
import { CARGAR_DEVOLUCION } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_Devolucion = (codDevolucion) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/devoluciones/' + codDevolucion,
			method: 'GET'
		})
		.then( response => {
			let devolucion = response.data;
			dispatch({
				type: CARGAR_DEVOLUCION,
				data: devolucion
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar devolución', mensaje: msgError}
			});
		});
	}
}
